<template>
  <table border="1px" 
            align="center" 
            bordercolor="white" 
            cellpadding="2px" 
            cellspacing="0px">
    
    <thead>
      <tr>
        <th>设备类型</th>
        <th>总数</th>
        <th>故障</th>
         <th>离线</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(person, index) in people" :key="index">
        <td>{{ person.id }}</td>
        <td>{{ person.name }}</td>
        <td>{{ person.age }}</td>
        <td>{{ person.pow }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  data() {
    return {
      people: [
        { id: "光伏", name: 189, age: 1 ,pow:0},
        { id: "储能", name: 6, age: 2,pow:1 },
        { id: "充电桩", name: 600, age: 0,pow:0 },
          { id: "其它", name: '', age: "",pow:"" },
      ],
    };
  },
};
</script>

<style>
table,td,th
{
	border:1px solid rgb(253, 248, 248);
}
table
{
	width:100%;
  
}
th
{
  border-left-style: none; border-right-style: none; 
  color: aliceblue;
  background-color:rgb(6, 68, 202);
	height:45px;
}
td
{
  
	height:30px;
	background-color:rgb(48, 112, 250);
}
</style>
